import React from 'react';
import { useGridContext } from '../../context/context';
import ExportToCsv from '../../util/ExportToCsv';

const ExportButton = () => {
  const { rows, columns } = useGridContext();

  return <ExportToCsv columns={columns} exportFileName={`connex-export`} rows={rows} />;
};

export default ExportButton;
